import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import CTA from '../components/CTA';
import SubscribeForm from '../components/SubscribeForm';
import Footer from '../components/Footer';

const Landing = () => (
  <>
    <Hero />
    <Features />
    <CTA />
    <SubscribeForm />
    <Footer />
  </>
);

export default Landing;
